<template>
<main>
<header>
  <section name="search">
    <!-- <h2 class="headText">Aktivní zakázky MyWay</h2> -->
    <div class='search_input'>
        <!-- <input class="search_spz"   @keyup.enter="doSearch()" type="text" v-model='searchSPZ'   placeholder="RZ vozidla" /> -->
        <input class="search_other" type="text" v-model='searchOTHER'
               @keyup.enter="doSearch"
               @click="clearInputIfCtrlPressed"
               placeholder="RZ, flotila, číslo zak. dealer / MyWay ..." />
        <button class="search_btn"  @click="doSearch" value='Hledat'>Hledat</button>
        <select class="filter" name="filter" v-model="filter" @change="handleFilterChange">
          <option value="2" v-if="!loggedUser.isFleet">Nahrané zakázky</option>
          <option value="5" v-if="!loggedUser.isFleet">Archivované zakázky</option>
          <option value="6" v-if="!loggedUser.isFleet">Smazané zakázky</option>
          <option value="7" v-if="!loggedUser.isFleet">Kategorie pneu</option>
          <option value="1">Všechno</option>
        </select>
    </div>
    <div class="categoryCheck search_input">
        <select class="filter" name="catChk" v-model="categoryCheck.flotila" @change="setCategoryCheck">
          <option v-for="opt in flotilaLIST" :key="opt" :value="opt"> {{ opt }}  </option>
        </select>
        <input class="search_spz" type="text" v-model='categoryCheck.spz'
               @change="setCategoryCheck"
               @click="clearInputIfCtrlPressed"
               placeholder="RZ" />
        <button class="search_btn" @click.prevent="doCatChkBtn">Hledat pneu kategorii</button>
    </div>
    <!-- <div id="status"> -->
        <!-- <ul class=""> -->
          <!-- <li><p>{{ countNoperformed }}</p>Nenahrané zakázky</li> -->
          <!-- <li><p>{{ countOpenjobs }}</p>Otevřené zakázky</li> -->
          <!-- <li><p>{{ countApprovrunning }}</p>Probíhá schvalování</li> -->
          <!-- <li><p>{{ countFinished }}</p>Dokončené zakázky</li> -->
        <!-- </ul> -->
    <!-- </div> -->
  </section>

  <section id="table">
    <table-lite
    :is-slot-mode="true"
    :is-loading= "table.isLoading"
    :columns=    "table.columns"
    :rows=       "table.rows"
    :total=      "table.totalRecordCount"
    :sortable=   "table.sortable"
    :messages=   "table.messages"
    :row-classes="table.rowClasses"
    @do-search=  "doSearch"
    @row-clicked="rowClicked"
    @is-finished="table.isLoading = false"
    >
    <template v-slot:statusNahrani="data">
        <status-red-green
          :id="data.value.id"
          :tooltip="data.value.statusNahrani"
          :status="data.value.calc_statusNahrani"
          @send-message="handleSendMessage"
        />
          <!-- :status="calcStatusRG(data.value.status)" -->
    </template>
    <template v-slot:shodaCeny="data">
        <!-- <status-red-green :status="data.value.shodaCeny==='OK'?'GREEN':'RED'" /> -->
        <!-- :tooltip="'This static text'" -->
        <status-red-green
          :tooltip="data.value.shodaCeny"
          :status="data.value.calc_shodaCeny" />
    </template>

    <template v-slot:stav_zakazky="data">
        <action-button
          :id="data.value.id"
          :tooltip="data.value.statusFakturace"
          :action="data.value.calc_stav_zakazky"
          @action-button-message="handleActionBtn" />
    </template>

    <template v-slot:akce="data">
        <div class="btnFlex">
        <action-button class="btnFirstIcon"
          v-if="data.value.calc_akce!='---'"
          :id="data.value.id"
          :tooltip="data.value.akce"
          :action="data.value.calc_akce"
          @action-button-message="handleActionBtn" />
        <action-button class="secondIconSpace" 
          v-if="data.value.calc_stav_zakazky==='Stale aktivni'||data.value.calc_stav_zakazky==='SCHVALOVANI PRERUSENO'||data.value.calc_stav_zakazky==='SCHVALENO_MB'||data.value.calc_stav_zakazky==='NENI_UZAVRENO'"
          :id="data.value.id"
          :action="MANUALNE_DOKONCIT"
          @action-button-message="handleActionBtn"
        />
        </div>
    </template>

    <template v-slot:imgLink="data">
        <img-link 
          :id="data.value.id"
          :trnID="data.value.trnID"
          :action="data.value.akce"
          :imgLink="data.value.imgLink"
          @img-link-show-log="handleShowLog" />
    </template>
    </table-lite>
  </section>
</header>
</main>
</template>

<script>
//import { computed } from "vue";
import TableLite from "vue3-table-lite";
// eslint-disable-next-line
import StatusRedGreen from './StatusRedGreenComponent.vue';
import ImgLink        from './ImgLinkComponent.vue';
import ActionButton   from './ActionButtonComponent.vue';
import { mapActions, mapState, mapMutations } from 'vuex';

// const sampleData = [
//     { id:1, created: (new Date()).toJSON().replace('T',' ').substr(0,19),
//       fleet: 'Arval', spz: 'SPZ1234', schvaleniTyp: 'Schvaleni manualni - zajisti si dealer', schvaleniID: '123-3432-1231', mywayID: 'abc-12345-xyz',
//       mywayCena: 1234.56, dealerCena: 1250, shodaCeny: 'OK', statusNahrani: 'ULOZENA',
//       mywayZprava: 'Zakazka 1122334455 byla uspesne zadana',
//       duvodUkonceni: 'Zakazka nebyla ulozena jelikoz obsahuje polozky kde je povinne schvaleni. Doplnte and poslete jeste jednou.',
//       imgLink: 'abcd.jpg'
//     },
// ];

export default {
// https://learnvue.co/LearnVue-Vue-3-Cheatsheet.pdf
  name: 'MainComponent',
  components: {
    TableLite,
    StatusRedGreen, // in template access as <status-red-green />
    ImgLink,
    ActionButton
  },
  computed: {
//       calcStatusRG(statusNahrani) {
//           return statusNahrani === 'ULOZENA' ? 'GREEN' : 'RED';
//       },
//    ...mapState('dash',{
//        isLoading:    state => state.isLoading,
//        dashTable:    state => state.table,
//    }),
    ...mapState('auth',['selectedServis','status','user','company']), 
    ...mapState('dash',['db','searchSPZ','searchOTHER','filter','isLoading','errorMessage','totalRecordCount',
                       'appLog','wrkLog','categoryCheck','dashID']),
    searchSPZ:{ // two-way binding
        get()    { return this.$store.state.dash.searchSPZ; },
        set(val) { this.setSearchSPZ(val); },
    },
    searchOTHER:{ // two-way binding
        get()    { return this.$store.state.dash.searchOTHER; },
        set(val) { this.setSearchOTHER(val); },
    },
    filter:{ // two-way binding
        get()    { return this.$store.state.dash.filter; },
        set(val) { this.setFilter(val); },
    },
    servisName:{
        get()    { return this.$store.state.auth.selectedServis; },
        set(val) { console.log('no change allowed', val); },
    },
    loggedUser:{
        get()    { return {status:  this.$store.state.auth.status,
                             user:  this.$store.state.auth.user,
                           company: this.$store.state.auth.company,
                           isFleet: this.$store.state.auth.user?.roles?.includes('FLEET')||false
                          };
                 },
        set(val) { console.log('no change allowed', val); },
    },

    totalRecordCount:{ // two-way binding
        get()    { return this.$store.state.dash.totalRecordCount; },
        set(val) { console.log('no change allowed', val);  },
    },
  },
  methods: {
    ...mapActions('dash', ['fetchData','fetchLogs','runAction']),
    ...mapMutations('dash',['setSearchSPZ','setSearchOTHER','setFilter', 'setTabControl','setDashID','setCategoryCheck']),

    handleSendMessageSimple(value) {
        console.log('From the child:', value);
    },
    handleSendMessage({status, isGreen}) {
        console.log('From the child:', status, isGreen);
    },
    async handleActionBtn({id, action, payload}) {
        console.log('Action:', id, action, payload);
        if(['Nelze','---','...','Stale aktivni'].includes(action)) {
            console.log('No action performed.');
            return;
        }
        await this.runAction({action, dashID: id, payload});
        const that = this;
        setTimeout(function(){
            that.fetchDataToTable();
        },500);
    },
//    calcStatusRG(status) {
//        return status === 'ULOZENA' ? 'GREEN' : 'RED';
//    },
    async fetchDataToTable() {
        this.table.isLoading = true;
        await this.fetchData();
        this.table.isLoading = false;
        this.table.rows = this.db;
        this.table.totalRecordCount = this.totalRecordCount;
    },
    async handleFilterChange(event) {
        const selectedValue = event.target.value;
        this.setFilter(selectedValue);
        await this.fetchDataToTable();
    },
    async doSearch(offset, limit, order, sort) {
        console.log('DO SEARCH!',offset, limit, order, sort);
        this.setTabControl({offset: typeof(offset)=="object"?0:offset, limit, order, sort});
        await this.fetchDataToTable();
    },
//    doCatChkFlotila(){
//        this.setCategoryCheck({ flotila: this.categoryCheck.flotila });
//    },
//    doCatChkSPZ() {
//        this.setCategoryCheck({ spz: this.categoryCheck.spz });
//        console.log('doCatChkSPZ', this);
//    },
    async doCatChkBtn() {
        // show modal window and wait till response come back
        if(!this.categoryCheck.spz) return;
        if( this.categoryCheck.spz?.length<5) return;
        const myAction = {
            action:  'categoryCheck',
            dashID:  0,
            payload: {
            spz:     this.categoryCheck.spz,
            flotila: this.categoryCheck.flotila}
        };
        console.log('Action:', myAction);
        await this.runAction(myAction);
    },
    clearInputIfCtrlPressed(event) {
      if (event.ctrlKey) {
        event.target.value = '';
        console.log(event);
        if(event.target.className==='search_other') this.setSearchOTHER('');
        if(event.target.className==='search_spz') this.setCategoryCheck({spz:''});
      }
    },
    rowClicked(row){
        this.setDashID(row.id);
        console.log("Row clicked!", row);
    },
    async handleShowLog(){
        console.log('handleShowLog', this.dashID);
        //await this.fetchLogs();
        //console.log('--- appLog ---')
        //console.table(this.appLog);
        //console.log('--- wrkLog ---')
        //console.table(this.wrkLog);
        //await this.fetchLogs();
        this.$router.push({name: 'appWrkLogs'});
    },
    handleKeyDown(event) {
      const isInputOrTextarea = event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA';

      if( !isInputOrTextarea && 
         (event.key === '*' ||
          event.key === 'NumpadMultiply' ||
          event.keyCode === 106)
        ) {
        this.starCount++;
        if (this.starCount === 4) {
          this.starCount = 0;
          this.handleShowLog();
        }
      } else {
        this.starCount = 0; 
      }
    },
  },
  async mounted() {
        document.addEventListener('keydown', this.handleKeyDown);
        if(this.loggedUser.isFleet){
            this.filter = 1;
        }
        await this.fetchDataToTable();
  },
  beforeUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
  },
  created() {
    // this.fetchTasks();
  },
  data() {
    return {
      MANUALNE_DOKONCIT: 'MANUALNE_DOKONCIT',
      flotilaLIST: [
        'Arval',
        'Autoexpert Rohlik',
        //'Autoleasing',
        'Ayvens',
        //'Birne',
        'BusinessLease', // externi script
        //'CSOB Leasing',
        'Leaseplan Drivalia', // externi script
        'MHC Mobility',
        //'Mototechna Drive',
        //'Reiffeisen Leasing',
        'SIXT',
        'SkoFIN', // externi script
        //'Solvent',
        //'Tedom',
        //'Unicredit Leasing',
        ],    
      countNoperformed: 0,
      countOpenjobs: 0,
      countApprovrunning: 0,
      countFinished: 0,
      countTotalperformed: 0,
      table: {
        isLoading: false,
        //totalRecordCount: 10,
        totalRecordCount: 0, // computed(() => { return this.table.rows.length;}),
        messages: {
          pagingInfo:           "Zobrazeno {0}-{1} z {2}",
          pageSizeChangeLabel:  "Počet záznamů: ",
          gotoPageLabel:        " Stránka: ",
          noDataAvailable:      "Data nenalezena",
        },
        rows: [],
        //rows: [...sampleData],
        //rows: [...sampleData,
        //       Object.assign({},sampleData[0],
        //        {id:2, statusNahrani:'NEULOZENA', shodaCeny:'ERR', imgLink:''})
        //      ],
//        rowClasses: function (row){
//            console.log('rowClasses', row);
//            return row.worker_status==='WRK:WIP' ? ['row-wrk-wip']:[];
//        },
        rowClasses: (row) => {
            return row.worker_status==='WRK:WIP' ? ['rowwrkwip']:
                   row.trnStatus==='ERROR' ? ['rowwrkerr'] : [];
        },
        sortable: {
          order: "id",
          sort: "desc",
        },
        columns:[
        {
          label: "ID",
          field: "id",
          width: "1%",
          sortable: true,
          isKey: true,
        },
//        {
//          label: "Nahráno",
//          field: "calc_updated",
//          width: "5%",
//          sortable: true,
//        },
        {
          label: "Fleet",
          field: "fleet",
          width: "5%",
          sortable: true,
        },
        {
          label: "RZ",
          field: "spz",
          width: "5%",
          sortable: true,
        },
//        {
//          label: "Typ schv.",
//          field: "schvaleniTyp",
//          width: "5%",
//          sortable: true,
//        },
//        {
//          label: "Schvalovací číslo",
//          field: "schvaleniID",
//          width: "5%",
//          sortable: false,
//        },
        {
          label: "Číslo zakázky MyWay",
          field: "mywayID",
          width: "5%",
          sortable: true,
        },
        {
          label: "Číslo zakazky dealera",
          field: "dealerDocID",
          width: "5%",
          sortable: true,
        },
//        {
//          label: "MyWay cena Kč",
//          field: "mywayCena",
//          width: "5%",
//          sortable: false,
//        },
//        {
//          label: "Dealer cena Kč",
//          field: "dealerCena",
//          width: "5%",
//          sortable: false,
//        },
        {
          label: "Shoda ceny",
          field: "shodaCeny",
          width: "2%",
          sortable: false,
//          display: function (row) {
//            const RG = row.shodaCeny === 'OK' ? 'green' : 'red';
//            return (`<div class="statusCircle ${RG}">${RG}</div>`);
//          },
        },
        {
          label: "Nahráno do MW",
          field: "statusNahrani",
          width: "5%",
          sortable: false,
          //display: function (row) {
          //  const RG = row.status === 'ULOZENA' ? 'green' : 'red';
          //  return (`<div class="statusCircle ${RG}">${RG}</div>`);
          //},
          // display: function (row) {
             // return  row.status === 'ULOZENA' ? 'GREEN' : 'RED';
          // },
        },
        {
          label: "Zpráva z MyWay",
          field: "mywayZprava",
          width: "20%",
          sortable: true,
        },
        {
          label: "Důvod ukončení nahrání",
          field: "duvodUkonceni",
          width: "20%",
          sortable: true,
        },
//        {
//          label: "Status nahrávaní",
//          field: "calc_status_nahrani",
//          width: "5%",
//          sortable: false,
//        },

        {
          label: "Stav zakázky",
          field: "stav_zakazky",
          width: "5%",
          sortable: true,
        },
        {
          label: "Akce",
          field: "akce",
          width: "5%",
          sortable: false,
        },
//        {
//          label: "Archivovat",
//          field: "archived",
//          width: "3%",
//          sortable: false,
//          headerStyles: { background: "gray" },
//        },
        {
          label: "Img",
          field: "imgLink",
          width: "3%",
          sortable: false,
        //  display: function (row) {
        //    const hasImg = row.imgLink > '' ? true : false;
        //    const img = require('@/assets/v2e.png'); // gif icon
        //    return hasImg ? (`<img src="${img}" class="imgFile"/>`) : '<span></span>';
        //  },
        },
        ]
      }, // table
  }} // return data
};
</script>

<style scoped>
/* ::v-deep is way of pushing css into components */
::v-deep(.statusCircle) {
    width: 5px;
    height: 5px;
    font-size: 1px;
    border-radius: 50%;
    padding: 7px 7px;
}
::v-deep(.green) {
    color: #068337;
    background-color: #068337;
}
::v-deep(.red) {
    color: #f7403a;
    background-color: #903333;
}
::v-deep(.btnFlex) {
    display: flex;
    justify-content: space-between;
}

main {
    width: 100%;
    margin-top: 20px;
}

section {
    display: flex;
    justify-content:flex-start;
    padding: 10px;
    border: 1px solid #444;
    background-color: #333;
    border-radius: 5px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

section[name="search"] {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

.headText{
    position: absolute;
    margin-top: -29px
}

.search_input, .categoryCheck {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.search_input > input,
.filter {
    border-radius: 5px;
    border: 1px solid #555;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    margin: 0px 6px 0px 0px;
    padding: 7px;
    color: #fff;
    background-color: #444;
}
.search_spz  { width: 100px; }
.search_other{ width: 250px; }

.search_input > input:hover { border-color: #8bc3ff; }

.search_input > button {
    border-radius: 5px;
    color: white;
    transition: background-color 0.3s;
}
.search_btn {
    font-size: medium;
    padding: 6px 20px;
    border: none;
    border-radius: 0px;
    background-color: #007bff;
    color: #fff;
    cursor: pointer;
    transition: background-color 0.3s;
}
.search_btn:hover {
    background-color: #0056b3;
}

.filter {
    width: 210px;
    border: 1px solid #555;
    background-color: #444;
    color: white;
    height: fit-content;
    margin-left: 30px;
/*    font-size: 12px;*/
}

select.filter:focus {
    outline: none;
    border-color: #8bc3ff;
}

select.filter:hover {
    border-color: #8bc3ff;
}

#status ul {
    display: flex;
    list-style-type: none;
    padding: 0;
    margin: 0;
}
#status  p {
    display: block;
    color: #ffcc00;
    font-size: 13px;
    margin-right: 10px;
    margin-block: 0px;
}

#status li {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    text-decoration: none;
    font-size: 12px;
    transition: 0.3s;
}

#status li:hover {background-color: #333; }

/*tr:hover {background-color: #444; }*/
/*tr:nth-child(even) {background-color: #333; }*/
/*.td-or{ color: #007bff; }*/

/*::v-deep(.vtl-table) { min-width: 2500px; }*/
/*::v-deep(.vtl-table) { max-width: 1850px; }*/
::v-deep(.vtl-table .vtl-thead .vtl-thead-th) {
  color: #fff;
}

::v-deep(.vtl-card) { width: 100%; }
::v-deep(.vtl-card-body) {
  background-color: #333333;  
}
::v-deep(.vtl-table td),
::v-deep(.vtl-table tr) {
  border: none;
  color: white;
}
::v-deep(.vtl-table-hover tbody tr):hover {
  color: red;
  background-color: #555555;
}
::v-deep(.vtl-paging-info) {
  color: lightblue;
  margin-top: 6px;
}
::v-deep(.vtl-paging-change-div) {
      margin-top: 6px;
}
::v-deep(.vtl-paging-count-label),
::v-deep(.vtl-paging-page-label) {
  color: lightblue;
}
::v-deep(dataTables_paginate) {
    margin-top: -6px;
}
::v-deep(vtl-paging-pagination-page-li){
    font-weight: normal;
    font-size: 10px;
}
::v-deep(.vtl-paging-pagination-page-link) {
    padding: 0.3rem 0.5rem;
    border: none;
    font-weight: bold;
    font-size: 12px;
}

::v-deep(.rowwrkwip) { background: #215f5e !important; }
::v-deep(.rowwrkerr) { background: #5c2121 !important; }

</style>